import { useEffect, useState } from "react";
import { userService } from "../services/user.service";
import { dashboardService } from "../services/dashboard.service";
import background from "../images/background.svg";
import discord_avatar from "../images/discord_avatar.svg";
import ConfirmDiscordUnbind from "../components/modals/ConfirmDiscordUnbind";
import { Navigate, useNavigate } from "react-router-dom";
import { AppRoutes } from "../AppRoutes";
import moment from "moment";
import JoinGuildDoneModal from "../components/modals/JoinGuildDoneModal";
import { config } from "../AppConfig";
import ChangePasswordModal from "../components/modals/ChangePasswordModal";
import { doLogout, useAuthDispatch, useAuthState, doRefreshUser } from "../context/AuthContext";
import FileSaver from "file-saver";

const UserDashboard = (props) => {
  const dispatch = useAuthDispatch();
  const { user } = useAuthState();

  const [discordBound, setDiscordBound] = useState();
  const [hasLicence, setHasLicence] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showJoinedGuildModal, setJoinedGuildModal] = useState(false);
  const [showPasswordChangeModal, setPasswordChangeModalOpen] = useState(false);

  useEffect(() => {
    setDiscordBound(user.discord_user !== null);
  }, [hasLicence]);

  const handleChangePasswordClick = async (e) => {
    setPasswordChangeModalOpen(!showPasswordChangeModal);
  };

  const handleManageSubscriptionClick = async (e) => {
    const portal = await dashboardService.createPortalSession();
    window.open(portal.url, "Manage Subscription", "width=1024,height=1024");
  };

  const handleSignOut = async () => {
    await doLogout(dispatch);
  };

  const handleDiscordBoundChange = (newValue) => {
    setDiscordBound(newValue);
  };

  const handleJoinDiscordClick = async () => {
    const response = await userService.joinDiscordserver();
    if (response.status >= 200) {
      setJoinedGuildModal(!showJoinedGuildModal);
    }
  };

  const handleConfirmDiscordUnbindModal = (e) => {
    if (discordBound) {
      setShowModal(!showModal);
    } else {
      window.location = `${config.url.API_BASE}/api/connect/discord`;
    }
  };

  const handleDownloadClick = async e => {
    e.preventDefault();
    const res = await dashboardService.downloadLatestVersion();
    FileSaver.saveAs(res.url, res.key);
  };

  const handleUnbindHwidClick = async e => {
    e.preventDefault();
    await userService.unbindHwid();
    await doRefreshUser(dispatch);
  };

  if (!user.licence) return <Navigate replace to="/bind" />;
  if (user.licence.current_subscription_id === null && user.licence.type !== "lifetime" && user.licence.type !== "weekly") {
    return <Navigate replace to="/subscribe" />;
  }

  return (
    <div className="relative h-screen overflow-hidden bg-indigo-900">
      <img src={background} className="absolute h-full w-full object-cover" />
      <div className="absolute inset-0 bg-black opacity-25"></div>
      <div
        className="container relative z-10 mx-auto flex-grow items-center md:px-12 lg:max-w-6xl xl:px-3 xl:px-0 xl:py-32">
        <div
          className="mx-auto h-auto flex-grow sm:mx-auto xl:grid xl:grid-cols-3 xl:gap-4 grid-flow-col auto-cols-auto ">

          {/*username section*/}
          <div className="xl:col-auto row-span-3 h-full">
            <div
              className="h-full xs:content-evenly xl:rounded-lg xl:border xl:border-gray-200 xl:shadow-md xl:dark:border-gray-700 xl:dark:bg-gray-800">
              <div className="flex  ">
                <div className="flex w-full flex-col justify-center gap-4 p-6 h-full">
                  <div className="flex items-center sm:space-x-4 xl:block xl:space-x-0 2xl:flex 2xl:space-x-4">
                    {discordBound ? (
                      <img
                        alt=""
                        src={user.discord_user.avatar}
                        className="mb-4 h-28 w-28 rounded-lg sm:mb-0 xl:mb-4 2xl:mb-0"
                      />
                    ) : (
                      <img
                        alt=""
                        src={discord_avatar}
                        className="mb-4 h-28 w-28 rounded-lg sm:mb-0 xl:mb-4 2xl:mb-0"
                      />
                    )}
                    <div className="h-auto pl-4">
                      <h3 className="mb-1 text-xl text-gray-900 dark:text-white">
                        {discordBound ? user.discord_user.tag : ""}
                      </h3>
                      <div className="mb-4 text-sm font-normal text-gray-500 dark:text-gray-400">
                        <a href="#" onClick={handleChangePasswordClick}>
                          Change Password
                        </a>
                      </div>
                      <ChangePasswordModal
                        open={showPasswordChangeModal}
                        setOpen={setPasswordChangeModalOpen}
                      />
                      <a
                        href="#"
                        onClick={handleSignOut}
                        className="bg-primary-700 hover:bg-primary-800 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 inline-flex items-center rounded-lg py-2 text-center text-sm font-medium text-white focus:ring-4"
                      >
                        Sign Out
                      </a>
                    </div>
                  </div>
                  <div className="grid flex-grow grid-cols-2 gap-4">
                    <div className="grid-span-1">
                      <div>
                        <button
                          onClick={handleConfirmDiscordUnbindModal}

                          className="inline-flex w-full min-w-full items-center justify-center rounded bg-gray-300 py-2 px-1 text-gray-800 hover:bg-gray-400 disabled:cursor-not-allowed disabled:bg-gray-700"
                        >
                          <span>
                            {!discordBound ? "Bind Discord" : "Unbind Discord"}
                          </span>
                        </button>

                        <ConfirmDiscordUnbind
                          handleDiscordBoundChange={handleDiscordBoundChange}
                          open={showModal}
                          setOpen={handleConfirmDiscordUnbindModal}
                        />
                      </div>
                    </div>
                    <div className="grid-span-1">
                      <div>
                        <button
                          onClick={handleDownloadClick}
                          disabled={!discordBound}
                          className="disabled:bg-gray-700 disabled:cursor-not-allowed inline-flex w-full min-w-full items-center justify-center rounded bg-gray-300 py-2 px-1 text-gray-800 hover:bg-gray-400"
                        >
                          <span>Download</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="grid flex-grow grid-cols-2 gap-4">
                    <div>
                      <button
                        onClick={handleJoinDiscordClick}
                        disabled={!discordBound}
                        className="disabled:bg-gray-700 disabled:cursor-not-allowed inline-flex w-full min-w-full items-center justify-center rounded bg-emerald-600 py-2 px-1 text-gray-100 hover:bg-emerald-400"
                      >
                        <span>Join Discord</span>
                      </button>
                      <JoinGuildDoneModal
                        open={showJoinedGuildModal}
                        setOpen={handleJoinDiscordClick}
                      />
                    </div>
                    <div>
                      <button
                        onClick={handleUnbindHwidClick}
                        className="disabled:bg-gray-700 disabled:cursor-not-allowed inline-flex w-full min-w-full items-center justify-center rounded bg-gray-300 py-2 px-1 text-gray-800 hover:bg-gray-400"
                      >
                        <span>Unbind HWID</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*membership section*/}
          <div className="h-full h-auto xl:col-span-2 row-span-3 h-full">
            <div
              className="flex flex-col sm:h-max xl:rounded-lg xl:border xl:border-gray-200 xl:shadow-md xl:dark:border-gray-700 xl:dark:bg-gray-800">
              <div
                className="flex flex-col dark:border-gray-700 xl:rounded-lg xl:border xl:border-gray-200 xl:shadow-md xl:dark:bg-gray-800">
                <div className="flex h-full flex-col justify-center gap-4 pt-6 xl:p-6">
                  <div className="items-center sm:flex sm:space-x-4 xl:block xl:space-x-0 2xl:flex 2xl:space-x-4">
                    <div className="mx-auto flex-grow items-center gap-4 px-4">
                      <div className="min-height-28 col-span-2 mb-4 rounded-md border border-gray-500">
                        {/* Table header */}
                        <div
                          className="flex justify-between rounded-t-md border-b border-gray-500 bg-gray-300 bg-[#27272a] p-3">
                          <span className="font-bold text-white">
                            Membership
                          </span>
                          <div>
                            <button
                              onClick={handleManageSubscriptionClick}
                              className="inline-flex min-w-full items-center justify-center rounded bg-gray-300 px-2 text-gray-800 hover:bg-gray-400"
                            >
                              <span className="text-center">Manage</span>
                            </button>
                          </div>
                        </div>
                        {/* Table Content */}
                        <div className="divide-y border-gray-500 bg-[#27272a] text-gray-400 ">
                          <div className="flex items-center justify-between px-3 py-2">
                            Key
                            <div>{user.licence.key}</div>
                          </div>
                          <div className="flex items-center justify-between border-gray-500 px-3 py-2">
                            Expiry
                            <div>
                              {new moment(user.licence.expiry).format(
                                "DD/MM/YYYY HH:mm:ss"
                              )}
                            </div>
                          </div>
                          <div className="flex items-center justify-between border-gray-500 px-3 py-2">
                            Email
                            <div>{user.email}</div>
                          </div>
                          <div className="flex items-center justify-between border-gray-500 px-3 py-2">
                            Status
                            <div>{user.licence.status.status}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="px-4">
                    <span className="text-xl font-bold text-white">Refer A Friend</span>
                    <p className="mt-2">
                      <span className="text-white">You will receive a free months membership worth £30 for each successful referral signup. This will be automatically applied
                      once your referee signs up! Simply send the below link and they will be re-directed to the sign-up page.</span>
                    </p>
                    <div className="flex-1 relative group max-w-4xl mt-4 ">
                      <input
                        value={`${config.url.DASH_BASE}/purchase/cIfKmL1IlevszR2voKudAKicjh654FCD?u=${user.id}`}
                        className="relative transition focus:!ring focus-within:z-20 bg-white bg-[#18181B] placeholder-gray-300 dark:placeholder-gray-500 text-gray-800 dark:text-white py-0 px-3 w-full disabled:cursor-not-allowed h-8 text-sm rounded-md input-group:rounded-none input-group:first:rounded-l-md input-group:last:rounded-r-md input-group:-ml-px input-group:first:!ml-0 !border-gray-200 dark:!border-gray-700 focus:!border-blue-300 dark:focus:!border-blue-400 !ring-blue-400 !ring-opacity-40">
                      </input>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </div>


        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
